import { AnyAction as AnyEvent } from 'redux'
import { SocialLiveCasinoLiveStats, SocialLiveCasinoGameLiveStat, BaccaratOutcome } from './LiveStatsState'
import { getLiveStats } from '../../services/GapApiService'
import { LogManager } from '../../LogManager'

export enum LiveStatsEvents {
    UPDATE_LIVE_STATS = 'UPDATE_LIVE_STATS',
}

export type LiveStatsEvent = AnyEvent | { type: LiveStatsEvents.UPDATE_LIVE_STATS; payload: { liveStats: SocialLiveCasinoLiveStats } }

export const updateLiveStatsOnSuccess = (liveStats: unknown) => ({
    type: LiveStatsEvents.UPDATE_LIVE_STATS,
    payload: {
        liveStats,
    },
})

export const fetchLiveStats = () => async (dispatch) => {
    try {
        const response = await getLiveStats()
        dispatch(updateLiveStatsOnSuccess(response))
    } catch (error) {
        LogManager.error({ message: 'Live stats fetch failed', error: error as Error })
    }
}
